import { ClientDataSource } from '@/types/ClientServiceType'
import axios from 'axios'
import { ILoggingService } from './LoggingService'

export default class ClientDataSourceService {
    private readonly _logging: ILoggingService
    private readonly baseUrl = '/ClientDataSources'

    constructor(logging: ILoggingService) {
        this._logging = logging
    }

    public async upsertClientDataSource(form: ClientDataSource) : Promise<void> {
        const url = `${this.baseUrl}/UpsertClientDataSource/`
        try {
            await axios.post(url, form)
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }

    public async deleteClientDataSource(form: ClientDataSource) : Promise<void> {
        const url = `${this.baseUrl}/DeleteClientDataSource/`
        try {
            await axios.post(url, form)
        } catch(error){
            this._logging.LogError(url, error)
            throw error
        }
    }
}